import { takeEvery, put, select, call } from 'redux-saga/effects'
import actionTypes from '../actionTypes'
import actions from '../actions'
import selectors from '../selectors'
import { showError } from '../../toastr/utils'
import makeAPIRequest from '../../api/sagas'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'
import { ORG_INACTIVE_NOTIFICATIONS_ENDPOINT } from 'app/constants/api/orgInactiveNotifications'

export default function* getAllSaga() {
  yield takeEvery(actionTypes.ORG_INACTIVE_NOTIFICATIONS.GET_ALL.REQUEST, handleGetAllRequest)
}

export function* handleGetAllRequest() {
  try {
    const pending = yield select(selectors.getPendingGetAll)
    if (!pending) {
      yield put(actions.setPending('getAll', true))
      const orgId = yield select(getViewOrganizationSettingsId)
      const { data } = yield call(makeAPIRequest, ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId), { method: 'GET' })
      yield put(actions.orgInactiveNotifications.getAll.success(data))
    }
  } catch (error) {
    showError()
    yield put(actions.orgInactiveNotifications.getAll.fail(error))
  }
}
